<template>
    <!--  style="height: calc(100vh - 121px)"-->
    <div>
        <div>
            <el-input style="width: 200px" placeholder="请输入项目名称" suffix-icon="el-icon-search"
                      v-model="projectName"></el-input>
            <!--            <el-input style="width: 200px" placeholder="请输入项目地址" suffix-icon="el-icon-position" class="ml-5"
                                  v-model="address"></el-input>-->
            <el-button class="ml-5" type="primary" @click="getData">搜索</el-button>
            <el-button type="warning" @click="reset_search">刷新</el-button>
        </div>

        <div style="margin: 10px 0">
            <el-button type="primary" @click="open_addProject_dialog">新建项目 <i class="el-icon-circle-plus-outline"></i>
            </el-button>
        </div>


        <!--表格区域 -->
        <el-table :data="tableData" border stripe :header-cell-class-name="'headerBg'" v-loading="loading"
                  show-overflow-tooltip
                  :sortable="false">
            <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
            <el-table-column prop="projectName" label="项目名称" width="120" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="address" label="项目地区" width="200" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="content" label="备注" width="80" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="devices" label="设备总数" width="80" align="center"></el-table-column>
            <el-table-column prop="online" label="在线数" width="80" align="center"></el-table-column>
<!--            <el-table-column prop="lightOn" label="亮灯数" width="80" align="center"></el-table-column>-->
            <el-table-column prop="buildDate" label="创建时间" width="120" align="center"
                             :formatter="dataFormat"></el-table-column>

            <el-table-column label="操作" align="center" min-width="300">
                <template slot-scope="scope">
                    <!--          <el-button type="success" slot="reference" @click="open_addDevice(scope.row)">添加设备</el-button>-->
                    <el-button type="primary" slot="reference" @click="goto_map(scope.row)">地图监控</el-button>
                    <el-button type="primary" slot="reference" @click="auto_plan(scope.row)">自动计划</el-button>
                    <!--                    <el-button type="primary" slot="reference" @click="goto_map2(scope.row)">电子地图2</el-button>-->
                    <el-button type="success" @click="open_edit_project(scope.row)">编辑</el-button>

                    <el-popconfirm
                        class="ml-5"
                        confirm-button-text='确定'
                        cancel-button-text='取消'
                        icon="el-icon-info"
                        icon-color="red"
                        title="您确定删除吗？"
                        @confirm="del_project(scope.row.id)"
                    >
                        <el-button type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>

                </template>
            </el-table-column>
        </el-table>
        <div style="padding: 10px 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[2, 5, 10, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <!--表格区域 -->

        <!--项目编辑框 -->
        <el-dialog  :title="title" :visible.sync="dialog_project_FormVisible" width="30%" @close="dialog_project_close">
            <el-form label-width="80px" size="small" :model="project" :rules="rules" ref="projectForm">
                <el-form-item label="项目名称" prop="projectName">
                    <el-input autocomplete="off" v-model="project.projectName"></el-input>
                </el-form-item>
                <el-form-item label="项目地区" prop="area">
                    <el-cascader

                        :options="options"
                        separator="-"
                        @change="handleChange"
                        size="medium" v-model="project.area"></el-cascader>
                    <!--          <el-input autocomplete="off"  v-model="project.address"></el-input>-->
                </el-form-item>

                <el-form-item label="项目备注" prop="">
                    <el-input autocomplete="off" v-model="project.content"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialog_project_FormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save_project">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog class="autoPlan_box"
            title="自动计划"
            :visible.sync="dialog_autoplan_Visible"
            center
            width="30%"
            :before-close="handleClose">

            <span>系统计划(根据地区日出日落时间)</span>
            <br/>
            <br/>
            <el-card class="box-card">
                <div class="text item">
                    执行时间:{{ sunTime }}
<!--                    v-model="this.project.sunPlan==1"  :value="project.sunPlan" -->
                    <el-switch style="margin-left: 50px"  :active-value="1" :inactive-value="0" :value="project.sunPlan"
                               active-color="#13ce66"
                               inactive-color="#ff4949" @change="plan_switch_sys($event,project)">
                    </el-switch>
                </div>
            </el-card><br/>
            <span>自定义计划
                <el-button type="primary" @click="open_addplan_dialog" style="margin-left: 20px">添加计划</el-button>
            </span>
            <br/>
            <br/>
            <el-card class="box-card" v-if="plan.length==0">
                <div class="text item">
                    当前无自定义计划
                </div>

            </el-card>

            <el-card class="box-card" v-if="plan.length!=0">
                <div v-for="(item,index) in plan" :key="index" class="text item" style="margin-bottom: 20px;border-bottom: 1px solid lightgray ">
                    <div style="margin-bottom: 0px">计划名称:{{ item.plan_name }}</div>
                    <div style="margin-bottom: 0px">计划名称:{{ item.state }}</div>
                    <div> 执行时间:{{ item.ptime }}
                        <el-switch style="margin-left: 50px" :value="item.state" :active-value="1" :inactive-value="0"
                                   active-color="#13ce66"
                                   inactive-color="#ff4949" @change="plan_switch($event,item)">
                        </el-switch>
                        <el-button style="margin-left: 30px " type="danger" round size="mini" @click="del_plan(item)">删除</el-button>
                    </div>
                </div>
            </el-card>

        </el-dialog>

        <el-dialog
            width="30%"
            title="添加自定义计划"
            center
            :visible.sync="dialog_autoplan_inner_Visible">

            <el-form :model="planform" :rules="planRules" ref="planForm">
                <el-form-item label="计划名称" label-width="120px" prop="planName">
                    <el-input v-model="planform.planName" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="起止时间" label-width="120px" prop="planStart">
                    <el-time-picker value-format="HH:mm" format="HH:mm"
                        v-model="planform.planStart" editable="false"
                        :picker-options="{
                           format:'HH:mm'
                        }"
                        placeholder="开始时间">
                    </el-time-picker>
                </el-form-item>

                <el-form-item label="起止时间" label-width="120px" prop="planEnd">
                    <el-time-picker value-format="HH:mm" format="HH:mm"
                        v-model="planform.planEnd" editable="false"
                        :picker-options="{
                            format:'HH:mm'
                        }"
                        placeholder="结束时间">
                    </el-time-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
               <el-button type="primary" @click="add_plan">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import {Loading} from 'element-ui';
import Vue from "vue";

Vue.prototype.openLoading = function () {
    const loading = this.$loading({           // 声明一个loading对象
        lock: true,                             // 是否锁屏
        text: '请稍后',                         // 加载动画的文字
        spinner: 'el-icon-loading',             // 引入的loading图标
        target: '.el-dialog',       // **需要遮罩的区域，这里写要添加loading的选择器**
        fullscreen: false,
        customClass: 'loadingclass'             // **遮罩层新增类名，如果需要修改loading的样式**
    })
    setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        loading.close();                        // 关闭遮罩层
    }, 5000)
    return loading;
}

export default {

    data() {
        return {
            selectedOptions: [],
            area: '',
            user: '',
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            title: '',
            loading: false,
            project: {},
            sunTime: '',
            plan: '',
            rules: {
                projectName: [
                    {required: true, message: '请输入项目名', trigger: 'blur'},
                    { min: 4, max: 30, message: '长度在 4 到 30 个字符', trigger: 'blur' }
                ],
                area: [
                    {required: true, message: '请输入项目地区', trigger: 'blur'}
                ],
            },
            planRules: {
                planName: [
                    {required: true, message: '请输入计划名', trigger: 'blur'},
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                ],
                planStart: [
                    {required: true, message: '请输入开始时间', trigger: 'blur'}
                ],
                planEnd: [
                    {required: true, message: '请输入结束时间', trigger: 'blur'}
                ],
            },
            options: [],
            projectName: "",
            projectName_: "",
            devices: "",
            address: "",
            form: {},
            planform:{},
            dialog_project_FormVisible: false,
            dialog_edit_project_Visible: false,
            dialog_addDevice_Visible: false,
            dialog_add_project_FormVisible: false,
            dialog_autoplan_Visible: false,
            dialog_autoplan_inner_Visible: false

        }
    },
    created() {
        this.user = JSON.parse(localStorage.getItem("user"))
        this.getData()
        //拼凑地区数据
        axios.get("./cityData.json").then(res => {
            let cityjson = res.data
            for (let i = 0; i < cityjson.length; i++) {
                let citys = []
                for (let j = 0; j < cityjson[i].citys.length; j++) {
                    let area = []
                    for (let k = 0; k < cityjson[i].citys[j].areas.length; k++) {
                        area.push({value: cityjson[i].citys[j].areas[k], label: cityjson[i].citys[j].areas[k]})
                    }
                    citys.push({value: cityjson[i].citys[j].name, label: cityjson[i].citys[j].name, children: area})
                }
                this.options.push({value: cityjson[i].name, label: cityjson[i].name, children: citys})
            }
        })

    },
    methods: {
        async getData() {

            this.loading = true
            let projects = await this.load();
            for (const v in projects.records) {
                let d = await this.getDevices(projects.records[v].id);
                projects.records[v].online = d.online
                projects.records[v].devices = d.device.length
                projects.records[v].lightOn = d.lightOn

            }
            this.tableData = projects.records
            this.total = projects.total
            this.loading = false
        },

        load() {
            const res = this.request.get("/project/page", {
                params: {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    projectName: this.projectName,
                    address: this.address,
                    userId: this.user.id
                }
            }).then(res => {
                console.log(res)
                return res.data

            })
            return res
        },
        getDevices(v) {
            const res = this.request.get("/devices/findByPid", {
                params: {
                    pid: v,
                    tid: ''
                }
            }).then(res => {
                return res.data
            })
            return res
        },
        getProject(id) {
            const res = this.request.get("/project/"+id, {

            }).then(res => {
                console.log('根据ID获取',res.data)
                this.project = res.data
            })

        },
        open_addProject_dialog() {
            this.dialog_project_FormVisible = true
            this.project = {}
            this.area = ''
            this.title = "新建项目"
        },


        open_edit_project(row) {
            this.project = JSON.parse(JSON.stringify(row))
            console.log(this.project)
            this.area = this.project.address.split("-")
            //this.project.address = this.project.address.split("-")
            this.project.area = this.project.address.split("-")
            this.dialog_project_FormVisible = true
            this.title = "编辑项目信息"
        },
        dialog_project_close() {
            this.$refs['projectForm'].clearValidate()
        },
        handleChange(value) {
            /*for (let i = 0; i < value.length; i++) {
                //this.project.address = value[i]+"-"
            }*/
            this.area = value
            console.log(value);
        },
        save_project() {
            this.project.userId = this.user.id
            console.log(this.area)

            this.$refs['projectForm'].validate((valid) => {
                if (valid) {
                    const rLoading = this.openLoading();
                    let city = ""
                    for (let i = 0; i < this.project.area.length; i++) {
                        city = city + this.project.area[i] + "-"
                    }
                    this.project.address = city.substring(0, city.length - 1)
                    console.log(this.project)
                    this.request.post("/project", this.project).then(res => {
                        rLoading.close();
                        if (res.code === '200') {
                            this.$message.success("操作成功")
                            this.dialog_project_FormVisible = false
                            this.getData()
                            this.project = {}
                        } else {
                            this.$message.error("操作失败")
                        }
                    })
                }
            });

        },

      /*  open_addDevice(value) {
            this.projectName_ = value.projectName
            this.dialog_addDevice_Visible = true
            this.form = {}
            this.form.projectId = value.id
        },
        save_device() {
            if (this.form.id == undefined || this.form.id == "") {
                this.$message.error("请输入id")
                return
            }
            if (this.form.nickname == undefined || this.form.nickname == "") {
                this.$message.error("请输入设备别名")
                return
            }
            this.request.post("/devices/banding", this.form).then(res => {
                console.log(res)
                if (res.code === '200') {
                    this.$message.success("添加成功")
                    this.dialog_addDevice_Visible = false
                    this.getData()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
*/

        del_project(id) {
            this.$confirm('此操作将同时删除项目下的所有设备, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.request.delete("/project/" + id).then(res => {
                    if (res.code === '200') {
                        this.$message.success("删除成功")
                        // this.load()
                        this.getData()
                    } else {
                        this.$message.error("删除失败")
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },

        goto_map(value) {
            sessionStorage.setItem('project', JSON.stringify(value))
            this.$router.push({path: '/map'});
        },

        auto_plan(value) {


            if (value.devices == 0) {
                this.$message({
                    message: '当前项目无设备,请先在地图里添加设备',
                    type: 'warning'
                });
            } else {
                this.dialog_autoplan_Visible = true
                this.get_SunTime(value.address)
                this.get_Plan(value.id)
                this.getProject(value.id)
            }
        },
        get_SunTime(address){
            this.request.get("/sunTime/getToday", {
                params: {
                    address: address
                }
            }).then(res => {
                console.log(res)
                this.sunTime = res.data.suntime.split("-")[1] + "-" + res.data.suntime.split("-")[0]
            })
        },
        get_Plan(pid){
            this.request.get("/plan/getPlanByProject", {
                params: {
                    pid: pid
                }
            }).then(res => {
               //
                this.plan = res.data
                console.log("111", this.plan[0])
            })
        },
        plan_switch(value,item){
            if(this.project.sunPlan==1){
                this.$message.warning("请先关闭系统计划")
                return false
            }
            console.log(value)
            console.log(item)
            let ptime2 = ''
            for (let v in this.plan) {
                if (this.plan[v].plan_id != item.plan_id && this.plan[v].state == 1) {
                    ptime2 = ptime2 + this.plan[v].ptime + ";"
                }
            }
            if (ptime2 != '') {
                if (item.state == 1) {
                    ptime2 = ptime2.substring(0, ptime2.length - 1)
                } else {
                    ptime2 = ";" + ptime2.substring(0, ptime2.length - 1)
                }
            }
            console.log(ptime2)

            let loading = this.$loading({
                text: "请稍后",
                lock:true,
                target: document.querySelector(".el-dialog__body"),
            });
            this.request.get("/plan/update_state", {
                params: {
                    id: item.plan_id,
                    state: item.state == 0 ? 1 : 0,
                    ptime: item.ptime,
                    ptime2: ptime2 //其他计划（开启状态）的执行时间
                }
            }).then(res => {
                loading.close()
                console.log(res)
                if (res.code === '200') {
                    this.$message.success("操作成功")
                    //this.project.sunPlan = res.data
                    this.get_Plan(this.project.id)
                } else {
                    this.$message.warning("操作失败")
                }
            })

        },
        plan_switch_sys(value,item){
            let ptime2 = ''
            for (let v in this.plan) {
                if (this.plan[v].state == 1) {
                    ptime2 = ptime2 + this.plan[v].ptime + ";"
                }
            }
            ptime2 = ptime2.substring(0, ptime2.length - 1)
            console.log(ptime2)
            console.log(this.project.sunPlan)
            console.log(value)
            console.log(item)

            let loading = this.$loading({
                text: "请稍后",
                lock:true,
                target: document.querySelector(".el-dialog__body"),
            });
            this.request.get("/project/updateSysPlan", {
                params: {
                    id: item.id,
                    state: item.sunPlan == 0 ? 1 : 0,
                    ptime:this.sunTime,
                    ptime2:ptime2
                }
            }).then(res => {
                loading.close()
                console.log(res)
                if (res.code === '200') {
                    this.$message.success("操作成功")
                    this.project.sunPlan = res.data
                } else {
                    this.$message.warning("操作失败")
                }
            })
        },
        del_plan(item){
            console.log(item)
            console.log(item.plan_id)
            console.log(this.plan)
            let ptime2 = ''
            for (let v in this.plan) {
                if (this.plan[v].plan_id != item.plan_id && this.plan[v].state == 1) {
                    ptime2 = ptime2 + this.plan[v].ptime + ";"
                }
            }
            if (ptime2 != '') {
                ptime2 = ptime2.substring(0, ptime2.length - 1)
            }
            console.log(ptime2)
            this.$confirm('是否删除这个计划?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.request.post("/plan/del_plan", {
                        plan_id: item.plan_id,
                        plan_detail_id: item.plan_detail_id,
                        project_id: item.project_id,
                        ptime: ptime2
                }).then(res => {
                    console.log(res)
                    if (res.code === '200') {
                        this.$message.success("删除成功")
                        // this.load()
                        this.get_Plan(item.project_id)
                    } else {
                        this.$message.warning("删除失败")
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        add_plan(){
            this.$refs['planForm'].validate((valid) => {
                if (valid) {
                    console.log(this.planform)
                    if(this.planform.planStart == this.planform.planEnd){
                        console.log(1)
                        this.$message.error('开始时间与结束时间不能一样');
                        return false
                    }
                    console.log(this.project)
                    //return false
                    this.request.post("/plan/save_plan", {
                        project_id: this.project.id,
                        plan_name: this.planform.planName,
                        state: 0,
                        p_node: 1,
                        pmonth: 0,
                        pday: 0,
                        ptime: this.planform.planStart+"-"+this.planform.planEnd
                    }).then(res => {
                        console.log(res)
                        if (res.code === '200') {
                            this.$message.success("添加成功")
                            this.get_Plan(this.project.id)
                            this.dialog_autoplan_inner_Visible = false
                        } else {
                            this.$message.warning("添加失败")
                        }
                    })

                }
            });
        },
        handleClose(done) {
            done();
            //this.getData()
        },

        open_addplan_dialog(){
            if(this.plan.length>=3){
                this.$message.warning("最多只能添加三条自定义计划")
                return false
            }
            this.dialog_autoplan_inner_Visible = true
            this.planform = {}
        },
        /*   goto_map2(value) {
               sessionStorage.setItem('project', JSON.stringify(value))
               this.$router.push({path: '/map'});
           },*/

        reset_search() {
            this.projectName = ""
            this.address = ""
            this.getData()
        },


        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.getData()
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum
            this.getData()
        },


        dataFormat(value) {
            let v = value.buildDate
            let year = v.substr(0, 4);
            let month = v.substr(5, 2)
            let day = v.substr(8, 2)
            let hour = v.substr(11, 2)
            let min = v.substr(14, 2)
            let second = v.substr(17, 2)
            //return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
            return year + "-" + month + "-" + day
        }
    }
}
</script>


<style>
.headerBg {
    background: #eee !important;
}

.text {
    font-size: 14px;
}

.item {
    padding: 3px 0;


}

.box-card {
    width: 100%
}
</style>
